import React from 'react';
import { string } from 'prop-types';
import { DE_DE } from 'utils/constants/LanguageRegionCode';
import useLanguageRegionCode from 'hooks/useLanguageRegionCode';
import classNames from 'classnames';
import * as styles from './styles/styles.module.scss';

const ActivitySuitabilityImage = ({ url, title, src }) => {
  const languageRegionCode = useLanguageRegionCode();

  return (
    <a href={url}>
      <div className={styles.container}>
        <div className={styles.opacCover} />
        <div className={classNames(styles.title, languageRegionCode === DE_DE && styles.germanSizedText)}>{title}</div>
        <img className={styles.img} src={src} alt="" />
      </div>
    </a>
  );
};

ActivitySuitabilityImage.propTypes = {
  url: string.isRequired,
  title: string.isRequired,
  src: string.isRequired
};

export default ActivitySuitabilityImage;
